module.exports = __webpack_public_path__ + "static/media/burst.791c2006.svg";